import React from "react"
import Logos from "./logos"

const Header = () => (
  <header>
    <div className="almo-new-header">
      <div className="fondazione-header hide-medium">
          <div className="container">
              <div className="fondazione-header__left"></div>
              <div className="fondazione-header__center">
                  <div className="fondazione-header__logo">
                    <a href="https://www.almonature.com/it/fondazione-capellino/" target="_blank" rel="noreferrer">
                      <Logos name="fondLogo" />
                    </a>
                  </div>
              </div>
              <div className="fondazione-header__right"></div>
          </div>
      </div>
    </div>
    <div className="project-logo-header">
      <div className="container">
          <ul className="project-icons">
            <li className="active">
              <a href="https://www.almonature.com/it/" target="_blank" rel="noreferrer">
                <Logos name="almoLogo" />
              </a>
            </li>
            <li>
              <a href="https://www.almonature.com/it/companion-animal-for-life/" target="_blank" rel="noreferrer">
                <Logos name="caflLogo" />
              </a>
            </li>
            <li>
              <a href="https://www.almonature.com/it/humans-and-wildlife/" target="_blank" rel="noreferrer">
                <Logos name="hwLogo" />
              </a>
            </li>
            <li>
              <a href="https://www.almonature.com/it/regenerating-villa-fortuna/" target="_blank" rel="noreferrer">
                <Logos name="rvfLogo" />
              </a>
            </li>
            <li>
              <a href="https://www.almonature.com/it/impact-on-biodiversity/" target="_blank" rel="noreferrer">
                <Logos name="bioLogo" />
              </a>
            </li>
          </ul>
      </div>
  </div>
  </header>
)

export default Header
